import React from "react";
import styled from "styled-components";
import InlineSvg from "react-inlinesvg";
import { t } from "i18next";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

import { colors } from "@constants/colors";
import Language from "./Language";
import { icons } from "@constants/icons";
import { MasterMedia } from "@constants/media";
import countryLangStore, {
  defaultCountry,
  defaultUser,
} from "@zustand/countryLang";
import LogoOnClick from "./LogoOnClick";

type Props = {
  children?: JSX.Element[] | JSX.Element | React.ReactNode;
  back?: boolean;
};

const Layout = ({ children, back = false }: Props) => {
  const navigator = useNavigate();
  const { setUser, setCountry, setLang } = countryLangStore();

  const handleLogout = () => {
    setUser(defaultUser);
    setCountry(defaultCountry);
    setLang(process.env.REACT_APP_COUNTRY_LANG ?? "en");
    navigator("/");
  };

  return (
    <Contents>
      <div className="header">
        <div className="header__btn">
          {back ? (
            <Button
              onClick={() => {
                handleLogout();
              }}
              className="btn"
            >
              <InlineSvg src={icons.arrow_back} />
              {t("Home:btn.back")}
            </Button>
          ) : (
            <div></div>
          )}
          <Language />
        </div>
        <LogoOnClick />
      </div>
      {children}
      <div className="footer_layout">{process.env.REACT_APP_VERSION}</div>
    </Contents>
  );
};

export default Layout;

const Contents = styled.div`
  background-color: ${colors.background};
  text-align: center;
  min-height: 100vh;
  padding: 30px;
  @media only screen and (max-width: ${MasterMedia.md}) {
    padding: 30px 20px;
  }
  .footer_layout {
    position: fixed;
    bottom: 0;
    left: 0;
  }
  .header {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    flex-wrap: wrap;
    height: 15vh;
    margin: 0 0 2%;
    @media only screen and (max-width: ${MasterMedia.md}) {
      margin-bottom: 20px;
    }
    &__btn {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      width: 100%;
      svg {
        width: 20px;
        height: 20px;
        margin: 0 10px 0 0;
      }
    }
  }
  .btn {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .logo {
    &__qovis {
      align-self: center;
      height: 45px;
      margin-top: 30px;
      @media only screen and (max-width: ${MasterMedia.md}) {
        height: 35px;
      }
    }
  }
`;
